import { isDate } from 'lodash-es';

export function isDateOnDateString(dateOrString: Date | string): dateOrString is Date {
  return isDate(dateOrString);
}
